import { message } from "antd"

export const handleGenericAsyncError = async <T,>(
  asyncMethod: () => Promise<T>,
  errorField: string = 'base'
): Promise<T>  => {
  try {
    return await asyncMethod()
  } catch (error: any) {
    const errorMessage = error?.errors?.[errorField] || error?.message || 'Something went wrong'
    message.error(errorMessage)
  }
}
